import DonationGroupListPage from "@/views/donationGroup/DonationGroupListPage.vue";
import DonationGroupDtlPage from "@/views/donationGroup/DonationGroupDtlPage.vue";

const donationGroupRoutes = [
    {
        path: "/donation-group",
        children: [
          {
            path: "",
            name: "DonationGroupListPage",
            component: DonationGroupListPage
          },
          {
            path: "donation-dtl/:donationGroupSeq",
            name: "DonationGroupDtlPage",
            components: {
              default: DonationGroupDtlPage,
            },
            props: {
              default: true,
            },
          },
        ],
      },
]

export default donationGroupRoutes;